import { render, staticRenderFns } from "./ActUploads__section.vue?vue&type=template&id=e8d8735a&scoped=true&"
import script from "./ActUploads__section.vue?vue&type=script&lang=js&"
export * from "./ActUploads__section.vue?vue&type=script&lang=js&"
import style0 from "./ActUploads__section.vue?vue&type=style&index=0&id=e8d8735a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d8735a",
  null
  
)

export default component.exports